import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('cantiere_token');
        if (token) {
            api.get('/auth/me')
                .then((res) => setUser(res.data))
                .catch(() => {
                    localStorage.removeItem('cantiere_token');
                    setUser(null);
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
        const res = await api.post('/auth/login', { email, password });
        localStorage.setItem('cantiere_token', res.data.token);
        // Refresh from /me so we get the full user payload incl. plan/trial status.
        try {
            const me = await api.get('/auth/me');
            setUser(me.data);
            return me.data;
        } catch {
            setUser(res.data.user);
            return res.data.user;
        }
    };

    const register = async (payload) => {
        // Attach current UI language so welcome email and AI use it
        const currentLang = (typeof window !== 'undefined' && localStorage.getItem('cantiereai_lang')) || 'it';
        const res = await api.post('/auth/register', { ...payload, language: currentLang });
        localStorage.setItem('cantiere_token', res.data.token);
        try {
            const me = await api.get('/auth/me');
            setUser(me.data);
            return me.data;
        } catch {
            setUser(res.data.user);
            return res.data.user;
        }
    };

    const logout = async () => {
        // Best-effort: notify the backend so the JWT is blacklisted server-side.
        // Even if the call fails (network, 401, etc.) we still clear the local
        // session — the user expects logout to always succeed locally.
        try {
            await api.post('/auth/logout');
        } catch (_) { /* swallow */ }
        localStorage.removeItem('cantiere_token');
        setUser(null);
    };

    const refreshUser = async () => {
        const res = await api.get('/auth/me');
        setUser(res.data);
        return res.data;
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
